import React, { useEffect, useState } from 'react';
import { Box, Button, Dialog, Flex, Text } from '@radix-ui/themes';
import QRCode from 'qrcode';
import { guestMenuPreviewUrl } from './guestMenuUrl';

export default function GuestMenuPhonePreview({tables,onClose}) {
  const table=tables[0];
  const url=table?guestMenuPreviewUrl(table.qr_token):'';
  const [qr,setQr]=useState('');const [error,setError]=useState(false);
  useEffect(()=>{
    let active=true;setQr('');setError(false);
    if(url)QRCode.toDataURL(url,{width:280,margin:4}).then(value=>{if(active)setQr(value);}).catch(()=>{if(active)setError(true);});
    return()=>{active=false;};
  },[url]);
  return <Dialog.Root open onOpenChange={open=>{if(!open)onClose();}}><Dialog.Content maxWidth="440px">
    <Dialog.Title>Open on my phone</Dialog.Title>
    <Dialog.Description>Scan to check your saved guest menu on a real device. This opens a design preview. Order submission is disabled.</Dialog.Description>
    <Flex direction="column" gap="4" align="center" mt="4">
      {qr?<img src={qr} alt="Scan to open the design preview" style={{width:240,maxWidth:'100%',height:'auto'}}/>:<Box py="5"><Text color="gray">{error?'Could not generate the QR code. Use the link below.':'Preparing QR code…'}</Text></Box>}
      {url&&<Button asChild variant="soft"><a href={url} target="_blank" rel="noopener noreferrer">Open design preview</a></Button>}
      <Text size="1" color="gray" align="center">You can try products, options and the basket, but cannot submit an order. Unsaved design changes do not appear on your phone.</Text>
      <Button variant="soft" color="gray" onClick={onClose}>Close</Button>
    </Flex>
  </Dialog.Content></Dialog.Root>;
}
